import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import EweProductCard from './EweProductCard';
import '../styles/ProductDetail.css';

const EweProductDetailPage = ({ cart, setCart, isLoggedIn }) => {
  const { productKey } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/ewe/products/${productKey}`
        );
        setProduct(response.data);
      } catch (error) {
        console.error('Error fetching product:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productKey]);

  const addToCart = () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    let guestCartId = localStorage.getItem("guestCartId");

    if (!isLoggedIn && !guestCartId) {
      guestCartId = 'guest-' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("guestCartId", guestCartId);
    }

    const payload = {
      productId: product.anProductKey,
      name: product.acName,
      price: product.anPrice,
      quantity: 1,
      ...(isLoggedIn ? { userId } : { guestCartId })
    };

    fetch( `${API_BASE_URL}/cart/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` })
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add to cart');
      alert('Product added to cart!');
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Error adding to cart: ' + error.message);
    });
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (!product) return <div className="error">Product not found</div>;

  return (
    <div className="product-detail-container">
      <EweProductCard product={product} onAddToCart={addToCart} />

      <div className="product-specifications">
        <h3>Specifikacije</h3>
        <div dangerouslySetInnerHTML={{ __html: product.acInlineSpecification }} />
      </div>

      <button className="add-to-cart-btn" onClick={addToCart}>
        Dodaj u Korpu
      </button>
    </div>
  );
};

export default EweProductDetailPage;